import { useMemo } from 'preact/hooks'
import get from 'lodash-es/get'
import isEmpty from 'lodash-es/isEmpty'
import omit from 'lodash-es/omit'

import { ARTICLE_RELATED_ENTRIES_SIZE, PATHS } from '../../js/config'
import Article from '../../js/components/page/Article'
import { getCategorySlugFromURI } from '../../js/utils/wp'
import { buildArticlePermalink } from '../../js/utils/urls'

import { buildPostParams } from './utils'

function Page(props) {
  const {
    year,
    month,
    day,
    slug,
    data,
  } = props

  const { related, post } = data

  const prev = buildPostParams(get(post, 'nextPost.node'))
  const next = buildPostParams(get(post, 'previousPost.node'))
  const rel = {
    archives: PATHS.ARCHIVES,
    next: isEmpty(next) ? undefined : {
      ...next.href,
      title: next.title,
    },
    prev: isEmpty(prev) ? undefined : {
      ...prev.href,
      title: prev.title,
    },
  }

  const relatedPosts = useMemo(
    () => related.slice(0, ARTICLE_RELATED_ENTRIES_SIZE),
    [related],
  )

  const categories = get(post, 'categories.nodes', []).map(({ uri, ...entry }) => ({
    ...entry,
    slug: getCategorySlugFromURI(uri),
  }))

  const tags = get(post, 'tags.nodes', [])

  const { author } = post
  const postData = omit(post, ['author', 'categories', 'tags', 'nextPost', 'previousPost'])

  const permalink = buildArticlePermalink({
    year,
    month,
    day,
    slug,
  })

  return (
    <Article
      year={year}
      month={month}
      day={day}
      slug={slug}
      permalink={permalink}
      rel={rel}
      author={author}
      post={postData}
      categories={categories}
      tags={tags}
      related={relatedPosts}
    />
  )
}

export default Page
